import angular from 'angular';
import chargecodeCreateComponent from './chargecode-create.component';

let chargecodeCreateModule = angular.module('chargecodeCreate', [
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
})

.component('chargecodeCreate', chargecodeCreateComponent);

export default chargecodeCreateModule;



// WEBPACK FOOTER //
// ./client/pages/admin/chargecode-create/chargecode-create.js